const name = 'BaseFade';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, { lazy = false, to = {}, from = {}, ...params } = {}) {
    if (to.opacity > 0) {
        to.autoAlpha = to.opacity;
        delete to.opacity;
    }
    if (from.opacity > 0) {
        from.autoAlpha = from.opacity;
        delete from.opacity;
    }
    return kit.engine.tween(elements, { duration, delay, lazy, to, from, ...params }, ['opacity', 'autoAlpha']);
}
export { name, properties, animate };
//# sourceMappingURL=baseFade.js.map